import { CmsTableProps } from '~/types/Cms';

const CmsTable = ({ data }: CmsTableProps) => {
  const rows = data.rows;
  if (!rows?.length) return null;

  const headerRow = data.headerRow === true;
  const headerColumn = data.headerColumn === true;

  // The admin currently sets one alignment for the whole table (`align`); the
  // per-column array wins where present, so this keeps working if that lands later.
  // Anything unset stays left-aligned, exactly as tables rendered before the feature.
  const alignOf = (cellIndex: number) => {
    const align = data.columnAlign?.[cellIndex] ?? data.align;
    return align && align !== 'left' ? { textAlign: align } : undefined;
  };

  const [firstRow, ...restRows] = rows;
  const bodyRows = headerRow ? restRows : rows;

  const renderBodyRow = (row: string[], rowIndex: number) => (
    <tr key={rowIndex}>
      {row.map((cell, cellIndex) =>
        headerColumn && cellIndex === 0 ? (
          <th key={cellIndex} scope="row" style={alignOf(cellIndex)}>
            {cell}
          </th>
        ) : (
          <td key={cellIndex} style={alignOf(cellIndex)}>
            {cell}
          </td>
        )
      )}
    </tr>
  );

  return (
    <div className="table-responsive">
      <table className="cms-table">
        {headerRow && (
          <thead>
            <tr>
              {firstRow.map((cell, cellIndex) => (
                <th key={cellIndex} scope="col" style={alignOf(cellIndex)}>
                  {cell}
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>{bodyRows.map(renderBodyRow)}</tbody>
      </table>
    </div>
  );
};

export default CmsTable;
